import { render } from "./ordemServicoDateTime.vue?vue&type=template&id=cee9f812"
import script from "./ordemServicoDateTime.vue?vue&type=script&lang=js"
export * from "./ordemServicoDateTime.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__